import * as HelpAPI from "api/HelpAPI";

export const TABLEAU_INTEGRATION_HELP_URL =
  "https://aible.zendesk.com/hc/en-us/articles/360043482551-How-to-set-up-your-Aible-Tableau-Extension";
export const SALESFORCE_INTEGRATION_HELP_URL =
  "https://aible.zendesk.com/hc/en-us/articles/360043482571-How-to-Set-up-your-Salesforce-Integration";
export const BOOMI_INTEGRATION_HELP_URL = "https://help.boomi.com/bundle/connectors/page/int-Aible_connector.html";

/* Selectors */

/* Actions */
export function openUri(uri, noPageChange = false) {
  if (noPageChange) {
    return window.location.assign(uri);
  }
  return window.open(uri, "_blank");
}

export function goToHelpUri(redirectUri = false, noPageChange = false) {
  return (dispatch, getState) => {
    return HelpAPI.getHelpUri().then((response) => {
      if (response) {
        let uri = response.redirect;
        if (redirectUri) {
          uri = uri + "&return_to=" + encodeURIComponent(redirectUri);
        }
        return openUri(uri, noPageChange);
      }
      return;
    });
  };
}

export function goToTableauIntegrationHelp() {
  return (dispatch, getState) => {
    return dispatch(goToHelpUri(TABLEAU_INTEGRATION_HELP_URL));
  };
}

export function goToSalesforceIntegrationHelp() {
  return (dispatch, getState) => {
    return dispatch(goToHelpUri(SALESFORCE_INTEGRATION_HELP_URL));
  };
}

export function goToBoomiIntegrationHelp() {
  return (dispatch, getState) => {
    return openUri(BOOMI_INTEGRATION_HELP_URL);
  };
}
